import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmployeeAdvanceRePaymentList = async ({
  companyCode,
  locationCode,
  fromDate,
  toDate,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  let endPoint = isAllCompanies
    ? Api_EndPoints.AllCompanies_GetEmployeeAdvancePaymentList
    : Api_EndPoints.GetEmployeeAdvanceList;

  let queryString = `?companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&FromDate=${fromDate}&ToDate=${toDate}`;
  if (employeeCode !== 0) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }
  if (isAllCompanies && userId) {
    queryString += `&UserId=${userId}`;
  }
  const { data } = await http_payroll.get(`${endPoint}${queryString}`);
  return data;
};

export const useEmployeeAdvanceRePaymentList = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetAttendanceDetailReport
        : Api_EndPoints.GetEmployeeAdvanceList,
    ],
    queryFn: () => getEmployeeAdvanceRePaymentList(input),
    // enabled: !!companyCode,
    // staleTime: 0,
    fetchOnWindowFocus: false,
  });
};
